module.exports = __webpack_public_path__ + "img/quanxian.88458474.svg";